import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getRatingsApi } from "./ratingApi";

export const getRatings = createAsyncThunk(
  "rating/getRatings",
  async ({ page, limit }, thunkAPI) => {
    try {
      const response = await getRatingsApi(page, limit);
      return response.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data);
    }
  }
);

const ratingSlice = createSlice({
  name: "rating",

  initialState: {
    ratings: [],
    total: 0,
    page: 1,
    totalPages: 1,
    loading: false,
    error: null,
  },

  reducers: {},

  extraReducers: (builder) => {

    builder
      .addCase(getRatings.pending, (state) => {
        state.loading = true;
      })

      .addCase(getRatings.fulfilled, (state, action) => {
        state.loading = false;
        state.ratings = action.payload.items;
        state.total = action.payload.total;
        state.page = action.payload.page;
        state.totalPages = action.payload.totalPages;
      })

      .addCase(getRatings.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

  },
});

export default ratingSlice.reducer;
